export { AvailabilityLabel as default } from './availability-label';
export * from './availability-label';
